import type { ContentObjectView, ProgramEntityContentObject } from 'models';
import { usePermissions } from 'permissions';
import { CommentButton } from '../comment-button';
import { ShareButton } from '../share-button';
import { ViewButton } from '../view-button';

type P = {
  item: ProgramEntityContentObject;
  onShowComments?: () => void;
  view: ContentObjectView;
};

const ProgramActionBar = ({ item, onShowComments, view }: P) => {
  const { canCommentContentObjectList } = usePermissions();

  const canComment = canCommentContentObjectList({ contentObject: item });

  return (
    <div className="program-action-bar">
      {view === 'bookmark' ? <ViewButton item={item} /> : null}
      {view === 'other' || view === 'feed' ? (
        <>
          {canComment ? <CommentButton onShowComments={onShowComments} /> : null}
          <ShareButton item={item} />
        </>
      ) : null}
    </div>
  );
};

export default ProgramActionBar;
